import MarkdownIt from 'markdown-it';
import React from 'react';
import { FiInfo } from 'react-icons/fi';
import MdEditor, { Plugins } from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';
import { DashboardHeader } from '../../core/DashboardHeader';
import { DashboardWrapper } from '../../core/DashboardWrapper';
import { FeatureImageCard } from '../../core/reusable-forms/FeatureImageCard';
import { RhButton, RhButtonMode } from '../../core/RhButton';
import { RhCard } from '../../core/RhCard';
import { H4 } from '../../core/Styles';
import { MissionStatementFormProps } from '../mission-statement-form.helper';

const mdParser = new MarkdownIt(/* Markdown-it options */);

MdEditor.unuse(Plugins.Header);
MdEditor.unuse(Plugins.Table);
MdEditor.unuse(Plugins.Image);
MdEditor.unuse(Plugins.FontUnderline);
MdEditor.unuse(Plugins.ListOrdered);
MdEditor.unuse(Plugins.ListUnordered);
MdEditor.unuse(Plugins.BlockCodeBlock);
MdEditor.unuse(Plugins.BlockCodeInline);
MdEditor.unuse(Plugins.BlockWrap);
MdEditor.unuse(Plugins.BlockQuote);

export const MissionStatementFormScreen = (props: MissionStatementFormProps) => {
  return (
    <DashboardWrapper>
      <DashboardHeader
        title="Mission Statement"
        actions={[
          <RhButton
            disabled={props.isLoading}
            loading={props.isLoading}
            key="cancel"
            mode={RhButtonMode.hollow}
            title="Cancel"
            onClick={props.userClickedCancel}
          />,
          <RhButton
            disabled={props.isLoading}
            loading={props.isLoading}
            key="save"
            title="Save Section"
            onClick={props.userClickedSaveSection}
          />,
        ]}
      />
      <div className="grid grid-cols-6 gap-5">
        {/* 1st column */}
        <div className="col-span-4">
          <MdEditor
            style={{ height: 600 }}
            value={props.formState.markdown}
            renderHTML={text => mdParser.render(text)}
            allowPasteImage={false}
            onChange={({ text }) => {
              props.userUpdatedFormState(prevState => ({
                ...prevState,
                markdown: text,
              }));
            }}
          />
        </div>
        {/* 2nd column */}
        <div className="col-span-2 space-y-6">
          <RhCard>
            <div className="space-y-2">
              <div className="flex items-start space-x-2">
                <FiInfo size={26} className="text-sky-600" />
                <H4>
                  This editor is using Markdown to render text. Supported syntax: Bold, Italic, Strikethrough, Link.{' '}
                  <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href="https://www.markdownguide.org/basic-syntax/"
                    className="underline">
                    Learn more
                  </a>
                </H4>
              </div>
            </div>
          </RhCard>
          <FeatureImageCard
            title="Thumbnail"
            value={props.formState.thumbnail}
            valueInUrl={props.formState.thunbnailUrl}
            onChange={value => {
              props.userUpdatedFormState({
                ...props.formState,
                thumbnail: value,
              });
            }}
            onRemove={() => {
              props.userUpdatedFormState({
                ...props.formState,
                thumbnail: null,
              });
            }}
          />
        </div>
      </div>
    </DashboardWrapper>
  );
};
